<template>
  <div>
    <v-footer class="footer-dva">
      <v-spacer />
      <v-container fluid class="footer-inner">
        <v-row justify="space-between"
          :class="{ 'pt-10 mt-12': $vuetify.breakpoint.smAndDown, 'mt-10': $vuetify.breakpoint.mdAndUp }">
          <v-col class="mt-0 pt-0" cols="12" md="3">
            <v-row class="mb-2 mt-0 mx-auto" justify="center">
              <p class="image-header">{{$t("footer.quick") }}</p>
            </v-row>
            <ul class="direct-access-list pl-0">
              <li>
                <a class="access-element" href="https://www.dvacapital.com/" target="_blank">
                  {{$t("footer.externalLinks.aboutDVA") }}
                </a>
              </li>
              <li>
                <a class="access-element" href="https://ayuda.dvacapital.com/es/" target="_blank">
                  {{$t("footer.externalLinks.helpCenter") }}
                </a>
              </li>
            </ul>
          </v-col>
          <v-col class="my-auto mt-0 pt-0" cols="12" md="3">
            <v-row class="mb-2" justify="center" align="start">
              <v-col cols="12">
                <p class="image-header">{{$t("footer.backedUp") }}</p>
              </v-col>
              <v-col cols="6">
                <a href="https://www.dvacapital.com" target="_blank" class="mx-1">
                  <v-img :src="require('@/assets/footer-dva.svg')" max-height="80" contain />
                </a>
              </v-col>
            </v-row>
            <v-row />
          </v-col>
          <!-- <v-col class="mt-0 pt-0" cols="12" md="3">
            <v-row class="mb-2" justify="center">
              <v-col cols="12">
                <p class="image-header center-in-page">{{$t("footer.cmf") }}</p>
              </v-col>
              <v-col>
                <a href="https://www.cmfchile.cl/" target="_blank" class="mx-1">
                  <v-img :src="require('@/assets/footer-cmf.svg')" contain max-height="55" />
                </a>
              </v-col>
            </v-row>
          </v-col> -->
          <v-col class="mt-0 pt-0" cols="12" md="3">
            <v-row class="mb-2" justify="center">
              <v-col cols="12">
                <p class="image-header">{{$t("footer.social") }}</p>
              </v-col>
              <v-col sm="8" md="8" lg="6">
                <v-row no-gutters class="mx-0">
                  <v-col>
                    <a href="https://www.instagram.com/dvacapital/" target="_blank">
                      <v-img :src="require('@/assets/icon-instagram.svg')" contain max-height="30" />
                    </a>
                  </v-col>
                  <v-col>
                    <a href="https://www.facebook.com/dvacapital/" target="_blank">
                      <v-img :src="require('@/assets/icon-facebook.svg')" contain max-height="30" />
                    </a>
                  </v-col>
                  <v-col>
                    <a href="https://www.linkedin.com/company/dva-capital-s-a-/" target="_blank">
                      <v-img :src="require('@/assets/icon-linkedin.svg')" contain max-height="30" />
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="white--text" justify="space-around" align="center">
          <v-dialog v-model="dialog" max-width="700">
            <template #activator="{ on, attrs }">
              <p class="image-header" v-bind="attrs" v-on="on" @click="dialog = true" id="disclaimer">
                {{ $i18n.t("footer.disclaimer.title") }}
              </p>
            </template>
            <v-card rounded elevation="0" class="card-modal">
              <v-card-title>{{ $i18n.t("footer.disclaimer.title") }}</v-card-title>
              <v-card-text>
                <p>
                  <i18n path="footer.disclaimer.first" tag="b"></i18n>
                </p>
                <i18n path="footer.disclaimer.second" tag="p">
                  <b>
                    <a href="http://www.cmfchile.cl/portal/principal/605/w3-propertyvalue-18490.html" target="_blank">
                      {{$t("footer.disclaimer.cmf") }}
                    </a>
                  </b>
                  <b>
                    <a href="https://www.spensiones.cl/apps/valoresCuotaFondo/vcfAFP.php?tf=A" target="_blank">{{
                     $t("footer.disclaimer.sp")
                    }}</a>
                  </b>
                </i18n>
                <i18n path="footer.disclaimer.third" tag="p"></i18n>
                <i18n path="footer.disclaimer.fourth" tag="p">
                  <b>{{$t("footer.disclaimer.fourthBold") }}</b>
                  <p>{{$t("footer.disclaimer.fourthRegular") }}</p>
                </i18n>
                <i18n path="footer.disclaimer.fifth" tag="p"></i18n>
                <i18n path="footer.disclaimer.sixth" tag="p"></i18n>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row class="white--text" justify="space-around" align="center">
          <div>{{ `&copy; ${new Date().getFullYear()} ${this.$i18n.t("footer.legal")}` }}</div>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped lang="scss">
.direct-access-list {
  list-style: none;
  text-align: center;
}

.access-element {
  color: white;
  text-decoration: none;
}

.access-element:hover {
  text-decoration: underline;
}

.image-header {
  color: white;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: bold !important;
}

.footer-dva {
  margin-top: 50px;
  background-color: #333333 !important;
}

.footer-regulatory-text {
  font-size: 10px;
}</style>
